// @flow

import styled from 'styled-components';
import { theme } from '../theme';

export const Term = styled.dl`
::after {
  content: ':';
}
`;

export const Definition = styled.dd`
  font-weight: bold;
  @media (${theme.device.sm}) {
    text-align: right;
}
`;

export const DataList = styled.dl`
  display: grid;
  grid-template-columns: auto;

  @media (${theme.device.sm}) {
    grid-template-columns: auto auto;
  }

  ${Term} {
    padding-top: .8em;
    padding-bottom: .4em;
  }

  ${Definition} {
    padding-top: .4em;
    padding-bottom: .8em;
    border-bottom: 1px solid #dfdfdf;
  }

  @media (${theme.device.sm}) {
    ${Term} {
      border-bottom: 1px solid #dfdfdf;
    }

    ${Term}, ${Definition} {
      padding-top: .8em;
      padding-bottom: .8em;
    }
  }

  > * :nth-last-child(2),
  > * :nth-last-child(1) {
    border-bottom: 0;
  }
`;
